<div class="visitor-leave-failed">
    <sc-title>
      <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-leave-failed.description"></sc-dictionary-label>
    </sc-title>

    <div class="error">
        <sc-icon iconClass="fa-circle-exclamation"></sc-icon>
    </div>

</div>
